// extracted by mini-css-extract-plugin
export default {"root":"PanelRoot_root__Tr5CK","scrollWrapper":"PanelRoot_scrollWrapper__2AaLF","body":"PanelRoot_body__ZjTaN"};